module.exports = __webpack_public_path__ + "static/media/duzeprzeszklenia.5fcddc09.svg";